import { render } from "./ActivityCenter.vue?vue&type=template&id=75c7cfc0&scoped=true"
import script from "./ActivityCenter.vue?vue&type=script&lang=js"
export * from "./ActivityCenter.vue?vue&type=script&lang=js"

import "./ActivityCenter.vue?vue&type=style&index=0&id=75c7cfc0&lang=scss"
import "./ActivityCenter.vue?vue&type=style&index=1&id=75c7cfc0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75c7cfc0"]])

export default __exports__
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDrawer,QTabPanels,QTabPanel});
